import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames/bind";
import PlayBackIcon from "../../../../../components/Icons/PlayBackIcon";
import DownLoadIcon from "../../../../../components/Icons/DownLoadIcon";
import { Pagination, Table as TB, Toast } from "../../../../../components";
import { downloadVideo, formatDateToTime, sorterArray } from "../../../../../utils";
import styles from "./Table.module.css";
import NameCol from "../../../../../components/NameCol";
import emptyImage from "../../../../../assets/images/Emty.png";
import axios from "axios";
import ProgressBar from "../../../../../components/ProgressBar";
import { useStoreContext } from "../../../../../hooks/useStoreContext";
import { TracingEventContext } from "../../../../../contexts";

const cx = classNames.bind(styles);
const Table = ({ data, pages, currentPage, getPage }) => {
  const { cameraCode, setCameraCode, url, setUrl, isShow, setIsShow, name,setName,listCheckApi } = useContext(TracingEventContext);
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [downloadInfo, setDownloadInfo] = useState({
    progress: 0,
    completed: false,
    total: 0,
    loaded: 0,
    index: null,
    cancel: false
  });
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext()
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const handleShowPlayBack = (path) => {

    async function addHistory() {
      try {
        setIsShow(!isShow);
        setUrl(`${process.env.REACT_APP_BASE_URL}event${path}`)
      } catch (e) {
        
      }
    }
    addHistory()
    setIsShow(true)
  };

  useEffect(() => {
    if (dataStore.pathNotification.path) {
      handleShowPlayBack(dataStore.pathNotification.path)
    }
  }, [dataStore.pathNotification])

  const handleDownLoad = async (url, name) => {
    try {
      Toast.open('Bắt đầu tải xuống', 'success')
      setIsLoading(true)
      const res = await axios.get(url, {
        onDownloadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          setDownloadInfo({
            progress: Math.floor((loaded * 100) / total),
            loaded,
            total,
            completed: false,
            name: name,
            cancel: false,
            index: null
          });
        },
        cancelToken: source.token,
      });
      await downloadVideo(url, res, name)
      setDownloadInfo((info) => ({
        ...info,
        completed: true,
      }));
    } catch (error) {
      if (axios.isCancel()) {
        setDownloadInfo((info) => ({
          ...info,
          cancel: true,
        }))
      } else {
        Toast.open('Có lỗi khi tải video', 'danger')
      }
    }
  }




  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      description: `${item.TIME_START ? formatDateToTime(item.TIME_START) : ''}`,
      user_add: item?.SUBJECT_NAME,
      action: (
        <div className={cx("actions")}>
          <div className={cx("btn", "confirm")} onClick={(e) => handleDownLoad(`${process.env.REACT_APP_BASE_URL}event${item?.PATH}`, name)}>
            <DownLoadIcon />
          </div>
          <div onClick={(e) => handleShowPlayBack(item.PATH)} className={cx("btn", "cancel")}>
            <PlayBackIcon />
          </div>
        </div >
      ),
    };
  });
  useEffect(() => {
    const newData = data.length > 0 ? [...data] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }


  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Thời gian'} handleSort={handleSort} method={'TIME_START'} />,
      key: "description",
    },
    {
      label: "Loại sự kiện",
      key: "user_add",
    },
    {
      label: "Hành động",
      key: "action",
    },
  ];

  const handleNext = () => {
    getPage(currentPage + 1)
  }
  const handlePrevious = (data) => {
    getPage(currentPage - 1)
  }

  const handleChosePage = (data) => {
    getPage(data)
  }

  const handleClose = () => {
    setIsLoading(false)
  }
  return (
    <div style={{flex:5,display:"flex",justifyContent:"space-between",flexDirection:"column"}}>
      <TB data={dataSource} colum={columns} />
      {data?.length === 0 && name && name !== 'Phát hiện chuyển động' && (
        <div className={cx("empty")}>
          <img src={emptyImage} alt="no-record" className={cx('empty-img')} />
          <p>Không có bản ghi trong thời gian được chọn</p>
        </div>
      )}
      {data?.length === 0 && name && name === 'Phát hiện chuyển động' && (
        <div className={cx("empty")}>
          <p>Vui lòng lựa chọn camera để xem video {name?.toLowerCase()}!</p>
        </div>
      )}
      {data?.length > 0 && (
        <div className={cx("pagination")}>
          <Pagination pages={pages} currentPage={currentPage} onNext={handleNext} onPrevious={handlePrevious} onClick={e => handleChosePage(e)} />
        </div>
      )}
      {isLoading && (
        <ProgressBar data={downloadInfo} onClose={handleClose} handleCancel={source.cancel()} />
      )}
    </div>
  );
};

export default Table;
